// InvestmentsHelper.js
import { GetAllFunds } from '../api/FundAPIHelper';
import { GetAllInvestmentRounds } from '../api/InvestmentRoundAPIHelper';
import { GetAllInvestmentTypes } from '../api/InvestmentTypeAPIHelper';
import { GetAllPortfolioCompanies } from '../api/PortcoAPIHelper';
import { GetAllInvestments } from '../api/InvestmentAPIHelper';

export const fetchInvestments = async (fundId = null) => {
    try {
        const investmentData = await GetAllInvestments();
        const fundRes = await GetAllFunds();
        const investmentRoundRes = await GetAllInvestmentRounds();
        const investmentTypeRes = await GetAllInvestmentTypes();
        const portfolioData = await GetAllPortfolioCompanies();

        const fundData = JSON.parse(fundRes.body);
        const investmentRoundData = JSON.parse(investmentRoundRes.body);
        const investmentTypeData = JSON.parse(investmentTypeRes.body);

        let result = investmentData.map((investment) => {
            const { internal_fund_id, portco_id, investment_round_id, investment_type_id, ...otherProps } = investment;

            const fund = fundData.find((f) => f.internal_fund_id === internal_fund_id);
            const portco = portfolioData.find((p) => p.portco_id === portco_id);
            const investmentRound = investmentRoundData.find((i) => i.investment_round_id === investment_round_id);
            const investmentType = investmentTypeData.find((i) => i.investment_type_id === investment_type_id);

            return {
                investmentId: investment.investment_id,
                investmentAmount: investment.investment_amount,
                investmentDate: investment.investment_date,
                fundId: fund?.internal_fund_id,
                fundName: fund?.fund_name,
                currentAum: fund?.current_aum,
                portcoId:  portco?.portco_id,
                portcoName: portco?.company_name,
                portcoLegalName: portco?.company_legal_name,
                investmentRoundId: investmentRound?.investment_round_id,
                investmentRound: investmentRound?.investment_round_name,
                investmentTypeId: investmentType?.investment_type_id,
                investmentType: investmentType?.investment_type_name,
                percentOfFundAum: ((Number(investment?.investment_amount) / Number(fund?.current_aum))).toFixed(4)
            };
        });

        if (fundId !== null) {
            result = result.filter(investment => investment.fundId === fundId);
        }

        return result;

    } catch (error) {
        console.error('Error fetching data: ', error);
        return [];
    }
}


export default fetchInvestments;
